import { TextField } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import request from '../../utils/request';

function PolicyQcInputFields({
  sectionName,
  label,
  qcRemarkOfEachSections,
  setQcRemarkOfEachSections,
  modouleDetail,
  checkAllModuleIsVerified,
  default: defaultValue = ''
}) {

  const typingTimer = useRef<any>(null);
  const isInitialized = useRef(false);
  const isDirty = useRef(false);

  const onSave = () => {
    request({
      url: 'insurancePolicy/savePolicyQcForm',
      method: 'POST',
      data: {
        policyId: modouleDetail.id,
        qcData: qcRemarkOfEachSections
      }
    }).then(() => {
      checkAllModuleIsVerified();
    });
  };

  /** Inject default without saving */
  useEffect(() => {
    if (isInitialized.current) return;

    const currentValue = qcRemarkOfEachSections?.[sectionName]?.value;

    if (!currentValue && defaultValue) {
      setQcRemarkOfEachSections(prev => ({
        ...prev,
        [sectionName]: {
          ...prev?.[sectionName],
          value: defaultValue
        }
      }));
    }

    isInitialized.current = true;
  }, []);

  /** Save only after user edits */
  useEffect(() => {
    const value = qcRemarkOfEachSections?.[sectionName]?.value;

    if (!isDirty.current) return;

    if (typingTimer.current) clearTimeout(typingTimer.current);

    typingTimer.current = setTimeout(() => {
      onSave();
      isDirty.current = false;
    }, 600);

    return () => clearTimeout(typingTimer.current);
  }, [qcRemarkOfEachSections?.[sectionName]?.value]);

  return (
    <TextField
      size="small"
      label={label}
      fullWidth
      multiline
      rows={3}
      name={sectionName}
      value={qcRemarkOfEachSections?.[sectionName]?.value || ''}
      onChange={(e) => {
        isDirty.current = true;

        setQcRemarkOfEachSections(prev => ({
          ...prev,
          [sectionName]: {
            ...prev?.[sectionName],
            value: e.target.value
          }
        }));
      }}
    />
  );
}

export default PolicyQcInputFields;
